import { Map, List } from 'immutable';

export enum ContentBlockModalType {
  VideoLibrary = 'add-video',
  MediaEmbed = 'add-media-embed',
  ChooseContentBlock = 'choose-content-block',
}

export interface EmbedService {
  id: string;
  title: string;
  icon: string;
  url?: string;
  helpUrl: string;
}

export type AttributeValue = string | number | boolean | null | undefined;
export type AttributeListValue = List<Map<string, AttributeValue>>;

export enum EmailLayout {
  Plain = 'plain',
  Html = 'html',
  Html2 = 'html_2',
  Html3 = 'html_3',
  Html4 = 'html_4',
}
